<div class="container bg-light position-relative app-participant-detail">
    <div class="row bg-white p-0">
        <!-- Col Left -->
        <div class="col-lg-8 bg-white pl-0 pr-0" style="position: relative">
            @if (data; as participant) { @if (loadedError) {
            <div class="pb-6">
                <div class="tab-pane" id="tab3-content" role="tabpanel" aria-labelledby="tab3">
                    <div class="text-center pt-7">
                        <svg class="icon icon--64 mb-4"><use [attr.xlink:href]="'#icon-' + sportName" /></svg>
                        <h4 class="font-weight-bold">{{ 'web.we_are_sorry' | translate }}</h4>
                        <p class="mb-6">{{ 'web.error_data_load' | translate }}</p>
                    </div>
                </div>
            </div>
            }
            <div class="pl-5 pt-5 pr-5 pr-md-3 pb-3 app-participant-detail__info">
                <div class="row">
                    <div class="col-md-10">
                        <div class="media">
                            <div class="img-circle img-circle--100 mr-3 rounded-circle">
                                <img
                                    [src]="cdn + participant.image | responsive : 'participant' : 'large'"
                                    [attr.alt]="participant.name"
                                    class="app-participant-logo"
                                    height="100"
                                    width="100"
                                />
                            </div>
                            <div class="media-body">
                                <div class="d-flex icon-wrappe r justify-content-start flex-wrap">
                                    <h1 class="mb-2 mr-3" data-cy="participant-name">
                                        {{ participant.name }}
                                        <app-favorite [participantId]="data.id" [type]="'participant'">
                                            <span notactive>{{ 'web.add_participant_to_favorites' | translate }}</span>
                                            <span active>{{
                                                'web.remove_participant_from_favorites' | translate
                                            }}</span>
                                        </app-favorite>
                                    </h1>
                                    @if (participant.country_flag) {
                                    <img
                                        class="mr-3 mb-2"
                                        [src]="cdn + participant.country_flag"
                                        [attr.alt]=""
                                        height="40"
                                    />
                                    }
                                    <div class="break-md"></div>
                                    <div class="mb-3 mb-lg-0">
                                        <ng-container
                                            ><app-last-matches [limit]="6" [matches]="formReverse"></app-last-matches
                                        ></ng-container>
                                    </div>
                                </div>
                                @if (participant.tournament && participant.tournament.length > 0) {
                                <div class="mb-2 h5 d-flex">
                                    @if (!isTennis) {
                                    <span class="font-weight-bold mr-1">
                                        <a
                                            [routerLink]="[
                                                '/page/sport/event',
                                                sportName + '-' + sportId,
                                                participant.tournament[0]?.tournament_id
                                            ]"
                                            class="text-reset"
                                        >
                                            {{ participant.tournament[0].sub_tournament_name }}</a
                                        >
                                    </span>
                                    }
                                    <span>({{ participant.tournament[0].category_name }})</span>
                                </div>
                                } @if (participant.venue) {
                                <div class="ng-star-inserted">
                                    @if (participant.venue?.stadium) {
                                    <span class="ng-star-inserted">
                                        <span class="text-gray">{{ 'web.home_stadium' | translate }}:</span>
                                        {{ participant.venue?.stadium }}
                                        @if (participant.venue.place) { ({{ participant.venue.place }}) } @if
                                        (client.use('map') && participant.venue.stadium_coords) { -
                                        <a class="link ext-link app-cursor" (click)="map = !map"
                                            >{{ 'web.map' | translate }} &nbsp;</a
                                        >
                                        }
                                    </span>
                                    } @if (participant.venue?.stadium_capacity) {
                                    <span class="ng-star-inserted">
                                        <span class="text-gray">{{ 'web.home_stadium_capacity' | translate }}:</span>
                                        {{ participant.venue?.stadium_capacity | appnumber }}
                                    </span>
                                    }
                                </div>
                                }
                                <div class="text-gray">
                                    <table>
                                        @if (participant?.ranking) {
                                        <tr>
                                            <td class="pr-lg-4">
                                                <div class="d-block d-md-inline app-word-nowrap">
                                                    <ng-container
                                                        >{{ 'web.' + participant.ranking.name | translate }}
                                                        <span class="font-weight-bold text-body">
                                                            <br />
                                                            #{{ participant.ranking.rank }} ({{
                                                                participant.ranking.year
                                                            }})
                                                        </span>
                                                        <span class="px-2"></span>
                                                    </ng-container>
                                                </div>
                                            </td>
                                        </tr>
                                        } @if (participant.meta?.main && participant.meta?.main?.length > 0) { @for
                                        (pData of metaMain; track $index) {
                                        <tr>
                                            @for (row of pData; track $index) {
                                            <td valign="top" class="pr-lg-4">
                                                <span class="app-word-nowrap text-gray">
                                                    {{ row.translation | translate }}:
                                                </span>
                                                <br />
                                                <div class="d-block d-md-inline font-weight-bold text-body">
                                                    @switch (row.name) { @case ('birthdate') {
                                                    {{ row.value | livDate : 'birthdate' }} ({{
                                                        row.value | livDate : 'age'
                                                    }}
                                                    {{ 'web.years-old' | translate | transinit }}) } @case
                                                    ('dominant-hand') {
                                                    {{ row.value | translate }}
                                                    } @default { @if (row.type === 'date') {
                                                    {{ row.value | livDate : 'localDate' }}
                                                    } @if (row.type !== 'date') {
                                                    {{ row.value }}
                                                    } } }
                                                    <!-- <ng-container *ngIf="row.type === 'birthdate'">
                                        {{ row.value | livDate: 'birthdate' }} ({{
                                        row.value | livDate: 'age'
                                        }}
                                        {{ 'web.years-old' | translate | transinit }})
                                      </ng-container>
                                      <ng-container *ngIf="row.type !== 'birthdate'">{{
                                        row.value
                                      }}</ng-container> -->
                                                </div>
                                            </td>
                                            }
                                        </tr>
                                        } }
                                    </table>
                                    @if (participant.f1_image) {
                                    <img [src]="participant.f1_image" class="img-fluid w-50" />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    @if (client.use('share')) {
                    <div class="col-md-2 text-md-right mt-2 mt-md-auto shared-btn-parent">
                        <div class="d-flex flex-row-reverse flex-md-column align-items-end">
                            <div class="dropdown ml-3 mb-md-2 dropdown-share">
                                <button
                                    class="btn btn-light dropdown-share-btn"
                                    (click)="shbClick($event)"
                                    [class.app-share-button--active]="shareBtnAct"
                                    type="button"
                                    id="dropdown-share-btn"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <svg class="icon"><use xlink:href="#icon-share" /></svg>
                                    <div class="app-share-button__links app-share-button__links--alternate">
                                        <app-shared-buttons [max]="sharedMax"></app-shared-buttons>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div class="nav-wrapper app-participant-detail__nav" style="position: relative">
                <!-- <div class="app-mob-nav-shadow"></div> -->
                <ul class="nav nav-tabs nav-tabs--shadows font-weight-bold pt-3" id="tabs-left" role="tablist">
                    <li class="nav-item">
                        <a
                            class="nav-link active px-3 px-md-5"
                            [class.active]="activeTab == 1"
                            id="tab1"
                            data-toggle="tab"
                            href="#tab1-content"
                            (click)="activeTabFce(1)"
                            role="tab"
                            aria-controls="tab1-content"
                            aria-selected="true"
                            >{{ 'web.races' | translate | transinit }}</a
                        >
                    </li>
                    @if (participant.meta.basic && participant.meta.basic.length > 0) {
                    <li class="nav-item">
                        <a
                            class="nav-link px-3 px-md-5"
                            data-cy="basic"
                            [class.active]="activeTab == 5"
                            id="tab5"
                            data-toggle="tab"
                            href="#tab5-content"
                            role="tab"
                            (click)="activeTabFce(5)"
                            aria-controls="tab5-content"
                            aria-selected="false"
                            >{{ 'web.basic' | translate | transinit }}</a
                        >
                    </li>
                    } @if (participant.meta.statistics && participant.meta.statistics.length > 0) {
                    <li class="nav-item">
                        <a
                            class="nav-link px-3 px-md-5"
                            data-cy="stats"
                            [class.active]="activeTab == 6"
                            id="tab6"
                            data-toggle="tab"
                            href="#tab6-content"
                            role="tab"
                            (click)="activeTabFce(6)"
                            aria-controls="tab6-content"
                            aria-selected="false"
                            >{{ 'web.statistics' | translate | transinit }}</a
                        >
                    </li>
                    } @if (participant.news?.length > 0 && client.use('news')) {
                    <li class="nav-item">
                        <a
                            class="nav-link px-3 px-md-5"
                            data-cy="players"
                            [class.active]="activeTab == 7"
                            id="tab7"
                            data-toggle="tab"
                            href="#tab7-content"
                            role="tab"
                            (click)="activeTabFce(7)"
                            aria-controls="tab7-content"
                            aria-selected="false"
                            >{{ 'web.news' | translate | transinit }}</a
                        >
                    </li>
                    } @if (hasStats) {
                    <li class="nav-item">
                        <a
                            class="nav-link px-3 px-md-5"
                            data-cy="participantStats"
                            [class.active]="activeTab == 9"
                            id="tab8"
                            data-toggle="tab"
                            href="#tab9-content"
                            role="tab"
                            (click)="activeTabFce(9)"
                            aria-controls="tab9-content"
                            aria-selected="false"
                            >{{ 'web.participant_stats' | translate | transinit }}</a
                        >
                    </li>
                    }
                </ul>
            </div>
            <div class="tab-content bg-white px-0 px-lg-3 py-3 position-relative">
                <div
                    class="tab-pane active"
                    [class.active]="activeTab == 1"
                    id="tab1-content"
                    role="tabpanel"
                    aria-labelledby="tab1"
                >
                    <!--Live matches-->
                    @if (data.data.live && data.data.live.length > 0) {
                    <h6
                        class="table-sport__head bg-dark app-text-dark-tournament bg-primary--light"
                        data-toggle="collapse"
                        data-target="#collapse-1-live"
                        role="button"
                        aria-expanded="true"
                        aria-controls="collapse-today"
                    >
                        <span class="table-sport__head__text app-text-dark-tournament">{{
                            'web.live_races' | translate
                        }}</span>
                    </h6>
                    <div class="collapse show" id="collapse-1-live">
                        @for (category of data.data.live; track $index) {
                        <div class="table-sport mx-n3 mx-sm-0 mb-3">
                            <h6
                                class="table-sport__head bg-dark text-white"
                                data-toggle="collapse"
                                [class.collapsed]="false"
                                [attr.data-target]="'#collapse-category-' + category.id"
                                role="button"
                                [attr.aria-expanded]="true"
                                [attr.aria-controls]="'collapse-category-' + category.id"
                            >
                                <img src="{{ category.image }}" alt="" width="20" class="mr-1" />
                                <span class="table-sport__head__text">{{ category.name }} {{ category.year }}</span>
                            </h6>
                            <div
                                class="table-sport__content collapse"
                                [class.show]="true"
                                [attr.id]="'collapse-category-' + category.id"
                            >
                                @for (stage of category.stages; track $index) {
                                <app-stage
                                    [showDate]="true"
                                    [showEventDetailBtn]="true"
                                    [stage]="stage"
                                    [categoryName]="category.name"
                                    [sportId]="sportId"
                                    [sportName]="sportName"
                                ></app-stage>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                    <!--End Live matches-->
                    <!--Participant not started matches-->
                    @if (data.data.not_started && data.data.not_started.length > 0) {
                    <h6
                        class="table-sport__head bg-dark text-white"
                        data-toggle="collapse"
                        data-target="#collapse-1-not_started"
                        role="button"
                        aria-expanded="true"
                        aria-controls="collapse-today"
                    >
                        <span class="table-sport__head__text">{{ 'web.not_started_races' | translate }}</span>
                    </h6>
                    <div class="collapse show" id="collapse-1-not_started">
                        @for (category of data.data.not_started; track $index) {
                        <div class="table-sport mx-n3 mx-sm-0 mb-3">
                            <h6
                                class="table-sport__head bg-dark text-white"
                                data-toggle="collapse"
                                [class.collapsed]="false"
                                [attr.data-target]="'#collapse-category-' + category.id"
                                role="button"
                                [attr.aria-expanded]="true"
                                [attr.aria-controls]="'collapse-category-' + category.id"
                            >
                                <img src="{{ category.image }}" alt="" width="20" class="mr-1" />
                                <span class="table-sport__head__text">{{ category.name }} {{ category.year }}</span>
                            </h6>
                            <div
                                class="table-sport__content collapse"
                                [class.show]="true"
                                [attr.id]="'collapse-category-' + category.id"
                            >
                                @for (stage of category.stages; track $index) {
                                <app-stage
                                    [showDate]="true"
                                    [showEventDetailBtn]="true"
                                    [stage]="stage"
                                    [categoryName]="category.name"
                                    [sportId]="sportId"
                                    [sportName]="sportName"
                                ></app-stage>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                    <!--End Participant notstarted matches-->
                    <!--Participant latest matches-->
                    @if (data.data.finished && data.data.finished.length > 0) {
                    <h6
                        class="table-sport__head bg-dark text-white"
                        data-toggle="collapse"
                        data-target="#collapse-1-latest"
                        role="button"
                        aria-expanded="true"
                        aria-controls="collapse-today"
                    >
                        <span class="table-sport__head__text">{{ 'web.latest_races' | translate }}</span>
                    </h6>
                    <div class="collapse show" id="collapse-1-latest">
                        @for (category of data.data.finished; track $index) {
                        <div class="table-sport mx-n3 mx-sm-0 mb-3">
                            <h6
                                class="table-sport__head bg-dark text-white"
                                data-toggle="collapse"
                                [class.collapsed]="false"
                                [attr.data-target]="'#collapse-category-' + category.id"
                                role="button"
                                [attr.aria-expanded]="true"
                                [attr.aria-controls]="'collapse-category-' + category.id"
                            >
                                <img src="{{ category.image }}" alt="" width="20" class="mr-1" />
                                <span class="table-sport__head__text">{{ category.name }} {{ category.year }}</span>
                            </h6>
                            <div
                                class="table-sport__content collapse"
                                [class.show]="true"
                                [attr.id]="'collapse-category-' + category.id"
                            >
                                @for (stage of category.stages; track $index) {
                                <app-stage
                                    [showDate]="true"
                                    [showEventDetailBtn]="true"
                                    [stage]="stage"
                                    [categoryName]="category.name"
                                    [sportId]="sportId"
                                    [sportName]="sportName"
                                ></app-stage>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    } @if (data.data.finished.length === 0 && data.data.not_started.length === 0 &&
                    data.data.live.length === 0 ) {
                    <div class="text-center pt-7 app-match-no-data">
                        <svg class="icon icon--64 mb-4">
                            <use [attr.xlink:href]="'#icon-' + sportName" />
                        </svg>
                        <h4 class="font-weight-bold">
                            {{ 'web.no_tournaments_found' | translate }}
                        </h4>
                    </div>
                    }
                    <!--End Participantlatest matches-->
                </div>
                @if (participant.meta.basic && participant.meta.basic.length > 0) {
                <div
                    class="tab-pane"
                    [class.active]="activeTab == 5"
                    id="tab5-content"
                    role="tabpanel"
                    aria-labelledby="tab5"
                >
                    <div class="table-responsive">
                        <div class="match-info__table small pb-2 text-center">
                            <div class="match-info__table__row player-record bg-dark text-white">
                                <div class="match-info__table__cell text-left font-weight-bold">&nbsp;</div>
                                <div class="match-info__table__cell text-left font-weight-bold">&nbsp;</div>
                            </div>
                            @for (row of participant.meta.basic; track $index) {
                            <div
                                class="match-info__table__row app-data-row-data player-record"
                                data-cy="participant-stats-basic"
                            >
                                <div class="match-info__table__cell text-left font-weight-bold border-top">
                                    {{ row.translation | translate }}:
                                </div>
                                <div class="match-info__table__cell text-left font-weight-bold border-top">
                                    @if (row.type === 'date') {
                                    {{ row.value | livDate : 'localDate' }}
                                    } @if (row.type !== 'date') {
                                    {{ row.value }}
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                } @if (participant.meta.statistics && participant.meta.statistics.length > 0) {
                <div
                    class="tab-pane"
                    [class.active]="activeTab == 6"
                    id="tab6-content"
                    role="tabpanel"
                    aria-labelledby="tab6"
                >
                    <div class="table-responsive">
                        <div class="match-info__table small pb-2 text-center">
                            <div class="match-info__table__row player-record bg-dark text-white">
                                <div class="match-info__table__cell text-left font-weight-bold">&nbsp;</div>
                                <div class="match-info__table__cell text-left font-weight-bold">&nbsp;</div>
                            </div>
                            @for (row of participant.meta.statistics; track $index) {
                            <div
                                class="match-info__table__row app-data-row-data player-record"
                                data-cy="participant-stats-stats"
                            >
                                <div class="match-info__table__cell text-left font-weight-bold border-top">
                                    {{ row.translation | translate }}:
                                </div>
                                <div class="match-info__table__cell text-left font-weight-bold border-top">
                                    @if (row.type === 'date') {
                                    {{ row.value | livDate : 'localDate' }}
                                    } @if (row.type !== 'date') {
                                    {{ row.value }}
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
                } @if (participant.news?.length > 0) {
                <div
                    class="tab-pane"
                    [class.active]="activeTab == 7"
                    id="tab7-content"
                    role="tabpanel"
                    aria-labelledby="tab7"
                >
                    <app-news [data]="participant.news"></app-news>
                </div>
                }
            </div>
            <app-google-map-modal
                [mapCoordinates]="participant.venue?.stadium_coords"
                [(visible)]="map"
            ></app-google-map-modal>
            } @else {
            <app-placeholder-tournament [progress]="false"></app-placeholder-tournament>
            }
        </div>
        <!-- Col Right -->
        <div class="col-lg-4 pl-3 pt-3 pr-3 d-none d-lg-block" [ngClass]="matchClass">
            <div [class.sticky-parent]="stickyDetail">
                @if (!deviceService.isMobile()) {
                <div [class.sticky-parent]="stickyDetail">
                    <app-stage-right-col
                        [sportId]="sportId"
                        [sportName]="sportName"
                        [standingsStageId]="stageId"
                        [stageParticipantStageId]="stageParticipantStageId"
                        [stageParticipantParticipantId]="stageParticipantParticipantId"
                    ></app-stage-right-col>
                    <app-stage-seasons-stats
                        [sportId]="sportId"
                        [sportName]="sportName"
                        [standingsData]="data.seasons_stats"
                    ></app-stage-seasons-stats>
                </div>
                }
            </div>

            @if (data.season_stats) {
            <div class="d-flex bg-white align-items-center app-form-canvas">
                <div class="col">
                    <hr />
                    <nav>
                        <ol class="app-small-nav">
                            @for (stats of data.season_stats | keys; track $index; let isFirst = $first) {
                            <li class="crumb">
                                <a
                                    [routerLink]="['./']"
                                    [queryParams]="{ statsKey: stats.key }"
                                    class="crumb__link"
                                    [class.active]="
                                        seasonStatsParam === stats.key || (seasonStatsParam === null && isFirst)
                                    "
                                    >{{ stats.value.tournamentName }}</a
                                >
                            </li>
                            }
                        </ol>
                    </nav>
                    @for (stats of data.season_stats | keys; track $index; let isFirst = $first) { @if (seasonStatsParam
                    === stats.key || (seasonStatsParam === null && isFirst)) {
                    <app-participant-season-stats
                        [betradarMajorLeague]="false"
                        [stats]="stats.value"
                    ></app-participant-season-stats>
                    } }
                </div>
            </div>
            }
        </div>
    </div>
    @if (client.use('sportQuickNav')) {
    <aside class="nav-sports d-none d-xl-block">
        <nav class="nav flex-column bg-light">
            <app-sport-navigation type="aside" [limit]="asideLimit" [sportId]="sportId"></app-sport-navigation>
            <a
                class="nav-link nav-link--more text-uppercase text-reset"
                [class.nav-link--more]="isAsideDefault()"
                [class.nav-link--less]="!isAsideDefault()"
                (click)="toggleAssideLimit()"
            >
                @if (isAsideDefault()) {
                <span>{{ 'web.more' | translate }}</span>
                } @if (!isAsideDefault()) {
                <span>{{ 'web.less' | translate }}</span>
                }
            </a>
        </nav>
    </aside>
    }
    <aside [class.d-xl-block]="client.use('sportQuickNav')" class="nav-sports nav-sports--extra d-none">
        <nav class="nav flex-column nav-side-menu bg-light">
            <app-side-menu-navigation [sportId]="sportId" [sportName]="sportName"></app-side-menu-navigation>
        </nav>
    </aside>
</div>
